import React from 'react';
import { connect } from 'react-redux';
import { RootState } from '../store';
import { withRouter, RouteComponentProps } from 'react-router';
import { Location } from '../store/locations/types';
import { IonCol, IonPopover, IonItem, IonContent } from '@ionic/react';
import { isloggedIn } from '../store/users/selectors';

const MarkerClusterer = require('node-js-marker-clusterer');

type Props =  RouteComponentProps<{}>  & ReturnType<typeof mapStateToProps> & {
  isLoggedIn: boolean;
  formattedUsersList: any;
  locations: Location[];
  mapCenter: Location;
  filter: string[];
  refocus: boolean;
  refresh: any;
  setRefresh: (refresh: boolean) => void,
}

type State = {
  showPopover: boolean;
  markerLoaded: boolean;
  data: string;
  lng: number;
  lat: number;
}

class Map extends React.Component<Props, State> {
  mapEle: any;
  map?: any;
  markers: any[];
  markerCluster: any;
  defaultState: State = {
    showPopover: false,
    markerLoaded: false,
    data: '{}',
    lng: 0,
    lat: 0,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      ...this.defaultState,
    };
    this.mapEle = React.createRef();
    this.markers = [];
  }

  componentDidMount() {
    this.map = new google.maps.Map(this.mapEle.current, {
      center: {
        lat: this.props.mapCenter.lat,
        lng: this.props.mapCenter.lng
      },
      zoom: 3
    });
    const myMap = this.map;
    this.map.addListener('center_changed', () => {
      this.setState({
        ...this.state,
        lat: myMap.getCenter().lat(),
        lng: myMap.getCenter().lng(),
      });
    });
    google.maps.event.addListenerOnce(this.map, 'idle', () => {
      if (this.mapEle.current) {
        this.mapEle.current.classList.add('show-map');
      }
    });
  }

  clearAllMarkers() {
    this.markers.forEach((item) => {
      item.setMap(null)
    });
    this.markers = [];
    this.markerCluster.clearMarkers();
  }

  componentDidUpdate(prevProps: Props) {
    let thisList = this.props.myList;
    let prevList = prevProps.myList;
    if (this.props.isLoggedIn) {
      thisList = this.props.formattedUsersList;
      prevList = prevProps.formattedUsersList;
    }
    const didFilterChange = prevProps.filter !== this.props.filter;
    const didMyListChange = thisList !== prevList;
    let refresh = false;
    // return;
    // if (didMyListChange && this.props.isLoggedIn) {
    //   refresh = true;
    // }
    if (didMyListChange && !refresh) {
      const newList = Object.keys(thisList).filter((item) => {
        if (!prevList[item] || !thisList[item]) {
          return true;
        }
        const isNewItemWithNoTag = thisList[item].tags.length === 0 && prevList[item].tags.length > 0;
        if (isNewItemWithNoTag) {
          return true;
        }
        const isNewItemWithNewTag = prevList[item].tags.length === 0 && thisList[item].tags.length > 0;
        if (isNewItemWithNewTag) {
          return true;
        }
        return false;
        // return prevList[item].tags !== thisList[item].tags
      });
      refresh = newList.length > 0;
    }
    // if (this.props.isLoggedIn) {
    //   refresh = this.props.refresh;
    //   this.props.setRefresh(false);
    // }
    if (didFilterChange || refresh) {
      if (this.props.filter.includes('all')) {
        this.addMarkers([]);
        return;
      }
      console.log('rerender');
      this.addMarkers(this.props.filter);
      return;
    }
    const isMarkersLoaded = this.markers.length > 0;
    if (isMarkersLoaded && prevList === thisList) {
      return;
    }
    if (isMarkersLoaded) {
      this.markers.forEach((item) => {
        const { id } = JSON.parse(item.title);
        const myPark = thisList[id];
        if (!myPark) {
          return;
        }
        console.log('changing icon')
        const icon = this.getIcon(myPark);
        item.setOptions({ icon });
      });
      return;
    }

    if (this.props.filter.length === 1 && this.props.filter[0] === 'all') {
      this.addMarkers([]);
    }
  }

  setShowPopover(status: boolean) {
    this.setState({
      ...this.state,
      showPopover: status,
    });
  }

  navigateToPlace = (placeId: string) => () => {
    this.setShowPopover(false);
    this.props.history.push(`/map/places/${placeId}`);
  }

  getIcon(park: any) {
    const prefix = '/assets/img';
    let icon = '';
    if (!park) {
      return icon;
    }
    const tags = park.tags || [];
    if (tags.length === 0) {
      return icon;
    }
    const visited = tags.includes('visited') ? 'visited' : '';
    const favorite = tags.includes('favorites') ? 'favorite' : '';
    const bucket = tags.includes('bucket') ? 'bucket' : '';
    return `${prefix}/${visited}${favorite}${bucket}.png`;
  }

  addMarkers(filters: string[]) {
    const {
      isLoggedIn, formattedUsersList
    } = this.props;
    if (this.props.locations.length === 0) {
      return;
    }
    if (filters.length > 0 || this.markers.length > 0) {
      this.clearAllMarkers();
    }
    const usersList: any = formattedUsersList;
    this.props.locations.forEach((markerData) => {
      // const href = `./places/places/${markerData.id}`;
      // let infoWindow = new google.maps.InfoWindow({
      //   content: `<a href="${href}">${markerData.name}</a>`
      // });
      let park = this.props.myList[markerData.parkCode];
      if (isLoggedIn) {
        park = usersList && usersList[markerData.parkCode];
      }
      // const park = this.props.myList[markerData.id];
      if (filters.length > 0) {
        if (!park) {
          return;
        }
        if (!park.tags || park.tags.length === 0) {
          return;
        }
        const intersection = park.tags.find((value: string) => filters.includes(value))
        if (!intersection) {
          return;
        }
      }

      const icon = this.getIcon(park);
      let marker = new google.maps.Marker({
        position: {
          lat: markerData.lat,
          lng: markerData.lng,
        },
        map: this.map,
        title: JSON.stringify(markerData),
        icon,
      });
      marker.addListener('click', () => {
        // infoWindow.open(this.map, marker);
        this.setShowPopover(true);
        this.setState({
          ...this.state,
          data: marker.getTitle() || '{}',
        });
      });
      this.markers.push(marker);
    });

    this.markerCluster = new MarkerClusterer( // eslint-disable-line
      this.map,
      this.markers,
      {
        imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      },
    );

    // zoom and center the map around the markers
    if (!this.props.refocus) {
      return;
    }
    if (this.map && this.markers.length) {
      const bounds = new google.maps.LatLngBounds();
      for (let i = 0; i < this.markers.length; i++) {
        bounds.extend(this.markers[i].getPosition());
      }
      this.map.fitBounds(bounds);
    }
  }

  render() {
    const { name, parkCode } = JSON.parse(this.state.data);
    let pic = this.props.parkMap[parkCode] && this.props.parkMap[parkCode].image;
    if (pic) {
      pic = '/assets/img/thumbs/' + pic;
    }

    return (
      <IonContent>
        <IonPopover
          isOpen={this.state.showPopover}
          onDidDismiss={e => this.setShowPopover(false)}
        >
          <div>
            <IonItem onClick={this.navigateToPlace(parkCode)}>
              <IonCol>
              <div dangerouslySetInnerHTML={{__html: name}} />
              </IonCol>
              <IonCol>
                <img src={pic} alt={name} />
              </IonCol>
            </IonItem>
          </div>
        </IonPopover>
        <div ref={this.mapEle} style={{height: '100%', width: '100%'}} id="map_canvas"></div>
      </IonContent>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  parkMap: state.places.parkMap,
  myList: state.places.myList,
});

export default withRouter(connect(
  mapStateToProps,
)(Map));
